/* fetchUser */
export const FETCH_USER_DATA_REQUEST = "FETCH_USER_DATA_REQUEST";
export const FETCH_USER_DATA_SUCCESS = "FETCH_USER_DATA_SUCCESS";
export const FETCH_USER_DATA_FAILURE = "FETCH_USER_DATA_FAILURE";

export const SAVE_USER_DATA = "SAVE_USER_DATA";
export const CLEAR_USER_DATA = "CLEAR_USER_DATA";
export const SAVE_COGNITO_USER = "SAVE_COGNITO_USER";